import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { BidsPerJobAnalysisPeriod } from 'components/reports/Metrics/constants'
import { VehicleTypeFilter } from 'generated/graphql'

export interface BidsPerJobAnalysisFilterValues {
  period: BidsPerJobAnalysisPeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const BIDS_PER_JOB_ANALYSIS_DEFAULT_FILTERS: BidsPerJobAnalysisFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const BidsPerJobAnalysisFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<BidsPerJobAnalysisFilterValues>({
    defaultValues: BIDS_PER_JOB_ANALYSIS_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
